<template>
<div class="chapter">
<div class="inner_page">
<nav epub:type="toc" id="toc" role="doc-toc">
<h1 id="toc-title">Burning the Water</h1>
<ol class="toc">
<li>
<span href="#/text/cover" title="Link target outside of Sample">Cover</span>
</li>
<li id="title_page">
<a href="#/text/title_page">Title Page</a>
</li>
<li id="toc-li-1">
<a href="#/text/ch001#epigraph">Epigraph</a>
</li>
<li id="toc-li-2">
<a href="#/text/ch002#prologue">Prologue</a>
<ol class="toc">
<li id="toc-li-3">
<a href="#/text/ch002#spring-1544-white-hall-london">Spring, 1544 – White Hall, London</a>
</li>
<li id="toc-li-4">
<a href="#/text/ch002#one-year-later-ancrum-moor-near-jedburgh">One year later – Ancrum Moor, near Jedburgh</a>
</li>
</ol>
</li>
<li id="toc-li-5">
<a href="#/text/ch003#chapter-one">Chapter One</a>
<ol class="toc">
<li id="toc-li-6">
<a href="#/text/ch003#berwick-on-the-tweed">Berwick on the Tweed</a>
<ol class="toc">
<li id="toc-li-7">
<a href="#/text/ch003#spring-1545">Spring, 1545</a>
</li>
</ol>
</li>
<li id="toc-li-8">
<a href="#/text/ch003#berwick-on-the-tweed-1">Berwick on the Tweed</a>
<ol class="toc">
<li id="toc-li-9">
<a href="#/text/ch003#eight-days-later">Eight days later</a>
</li>
</ol>
</li>
</ol>
</li>
<li id="toc-li-10">
<span href="#/text/ch004#chapter-two" title="Link target outside of Sample">Chapter Two</span>
<ol class="toc">
<li id="toc-li-11">
<span href="#/text/ch004#south-of-berwick-on-the-tweed" title="Link target outside of Sample">South of Berwick on the Tweed</span>
<ol class="toc">
<li id="toc-li-12">
<span href="#/text/ch004#a-day-later" title="Link target outside of Sample">A day later…</span>
</li>
</ol>
</li>
</ol>
</li>
<li id="toc-li-13">
<span href="#/text/ch005#chapter-three" title="Link target outside of Sample">Chapter Three</span>
<ol class="toc">
<li id="toc-li-14">
<span href="#/text/ch005#near-the-bastel-house-of-akeld" title="Link target outside of Sample">Near the bastel house of Akeld</span>
<ol class="toc">
<li id="toc-li-15">
<span href="#/text/ch005#a-day-later-1" title="Link target outside of Sample">A day later</span>
</li>
</ol>
</li>
</ol>
</li>
<li id="toc-li-16">
<span href="#/text/ch006#chapter-four" title="Link target outside of Sample">Chapter Four</span>
<ol class="toc">
<li id="toc-li-17">
<span href="#/text/ch006#in-the-tower-at-akeld" title="Link target outside of Sample">In the tower at Akeld</span>
<ol class="toc">
<li id="toc-li-18">
<span href="#/text/ch006#not-long-after" title="Link target outside of Sample">Not long after</span>
</li>
</ol>
</li>
<li id="toc-li-19">
<span href="#/text/ch006#five-miles-away" title="Link target outside of Sample">Five miles away</span>
<ol class="toc">
<li id="toc-li-20">
<span href="#/text/ch006#at-the-same-time" title="Link target outside of Sample">At the same time…</span>
</li>
</ol>
</li>
</ol>
</li>
<li id="toc-li-21">
<span href="#/text/ch007#chapter-five" title="Link target outside of Sample">Chapter Five</span>
<ol class="toc">
<li id="toc-li-22">
<span href="#/text/ch007#in-the-tower-at-akeld-1" title="Link target outside of Sample">In the tower at Akeld</span>
<ol class="toc">
<li id="toc-li-23">
<span href="#/text/ch007#dawn-the-next-day" title="Link target outside of Sample">Dawn the next day…</span>
</li>
</ol>
</li>
<li id="toc-li-24">
<span href="#/text/ch007#not-far-away" title="Link target outside of Sample">Not far away…</span>
</li>
<li id="toc-li-25">
<span href="#/text/ch007#even-closer" title="Link target outside of Sample">Even closer…</span>
</li>
<li id="toc-li-26">
<span href="#/text/ch007#not-long-after-1" title="Link target outside of Sample">Not long after…</span>
</li>
</ol>
</li>
<li id="toc-li-27">
<span href="#/text/ch008#chapter-six" title="Link target outside of Sample">Chapter Six</span>
<ol class="toc">
<li id="toc-li-28">
<span href="#/text/ch008#in-the-tower-at-akeld-2" title="Link target outside of Sample">In the tower at Akeld</span>
<ol class="toc">
<li id="toc-li-29">
<span href="#/text/ch008#sometime-later" title="Link target outside of Sample">Sometime later…</span>
</li>
</ol>
</li>
<li id="toc-li-30">
<span href="#/text/ch008#the-tower-at-akeld" title="Link target outside of Sample">The tower at Akeld</span>
<ol class="toc">
<li id="toc-li-31">
<span href="#/text/ch008#later" title="Link target outside of Sample">Later…</span>
</li>
</ol>
</li>
</ol>
</li>
<li id="toc-li-32">
<span href="#/text/ch009#chapter-seven" title="Link target outside of Sample">Chapter Seven</span>
<ol class="toc">
<li id="toc-li-33">
<span href="#/text/ch009#in-the-tower-at-akeld-3" title="Link target outside of Sample">In the tower at Akeld</span>
<ol class="toc">
<li id="toc-li-34">
<span href="#/text/ch009#the-second-day" title="Link target outside of Sample">The second day…</span>
</li>
</ol>
</li>
</ol>
</li>
<li id="toc-li-35">
<span href="#/text/ch010#chapter-eight" title="Link target outside of Sample">Chapter Eight</span>
<ol class="toc">
<li id="toc-li-36">
<span href="#/text/ch010#in-the-tower-at-akeld-4" title="Link target outside of Sample">In the tower at Akeld</span>
<ol class="toc">
<li id="toc-li-37">
<span href="#/text/ch010#afternoon-of-the-second-day" title="Link target outside of Sample">Afternoon of the second day…</span>
</li>
</ol>
</li>
</ol>
</li>
<li id="toc-li-38">
<span href="#/text/ch011#chapter-nine" title="Link target outside of Sample">Chapter Nine</span>
<ol class="toc">
<li id="toc-li-39">
<span href="#/text/ch011#in-the-tower-at-akeld-5" title="Link target outside of Sample">In the tower at Akeld</span>
<ol class="toc">
<li id="toc-li-40">
<span href="#/text/ch011#night-of-the-second-day" title="Link target outside of Sample">Night of the second day…</span>
</li>
</ol>
</li>
</ol>
</li>
<li id="toc-li-41">
<span href="#/text/ch012#chapter-ten" title="Link target outside of Sample">Chapter Ten</span>
<ol class="toc">
<li id="toc-li-42">
<span href="#/text/ch012#later-out-on-the-cheviot-hills" title="Link target outside of Sample">Later, out on the Cheviot hills…</span>
</li>
<li id="toc-li-43">
<span href="#/text/ch012#the-bastel-house-of-akeld" title="Link target outside of Sample">The bastel house of Akeld</span>
<ol class="toc">
<li id="toc-li-44">
<span href="#/text/ch012#the-next-morning" title="Link target outside of Sample">The next morning…</span>
</li>
</ol>
</li>
<li id="toc-li-45">
<span href="#/text/ch012#somewhere-in-the-cheviot-hills" title="Link target outside of Sample">Somewhere in the Cheviot hills</span>
<ol class="toc">
<li id="toc-li-46">
<span href="#/text/ch012#at-the-same-time-1" title="Link target outside of Sample">At the same time…</span>
</li>
</ol>
</li>
</ol>
</li>
<li id="toc-li-47">
<span href="#/text/ch013#chapter-eleven" title="Link target outside of Sample">Chapter Eleven</span>
<ol class="toc">
<li id="toc-li-48">
<span href="#/text/ch013#eglingham-hall-a-days-march-south-of-wooler" title="Link target outside of Sample">Eglingham Hall, a day’s march south of Wooler</span>
<ol class="toc">
<li id="toc-li-49">
<span href="#/text/ch013#at-the-same-time-2" title="Link target outside of Sample">At the same time…</span>
</li>
</ol>
</li>
<li id="toc-li-50">
<span href="#/text/ch013#akeld" title="Link target outside of Sample">Akeld</span>
<ol class="toc">
<li id="toc-li-51">
<span href="#/text/ch013#at-the-same-time-3" title="Link target outside of Sample">At the same time…</span>
</li>
</ol>
</li>
<li id="toc-li-52">
<span href="#/text/ch013#twa-corbies" title="Link target outside of Sample">Twa Corbies</span>
<ol class="toc">
<li id="toc-li-53">
<span href="#/text/ch013#at-the-same-time-4" title="Link target outside of Sample">At the same time…</span>
</li>
</ol>
</li>
</ol>
</li>
<li id="toc-li-54">
<span href="#/text/ch014#chapter-twelve" title="Link target outside of Sample">Chapter Twelve</span>
<ol class="toc">
<li id="toc-li-55">
<span href="#/text/ch014#later-at-akeld" title="Link target outside of Sample">Later, at Akeld…</span>
</li>
</ol>
</li>
<li id="toc-li-56">
<span href="#/text/ch015#chapter-thirteen" title="Link target outside of Sample">Chapter Thirteen</span>
<ol class="toc">
<li id="toc-li-57">
<span href="#/text/ch015#later-at-akeld-1" title="Link target outside of Sample">Later, at Akeld…</span>
</li>
<li id="toc-li-58">
<span href="#/text/ch015#a-few-miles-away-at-twa-corbies" title="Link target outside of Sample">A few miles away, at Twa Corbies…</span>
</li>
</ol>
</li>
<li id="toc-li-59">
<span href="#/text/ch016#chapter-fourteen" title="Link target outside of Sample">Chapter Fourteen</span>
<ol class="toc">
<li id="toc-li-60">
<span href="#/text/ch016#later-at-kirknewton-near-akeld" title="Link target outside of Sample">Later, at Kirknewton near Akeld…</span>
</li>
<li id="toc-li-61">
<span href="#/text/ch016#akeld-at-the-same-time" title="Link target outside of Sample">Akeld, at the same time…</span>
</li>
</ol>
</li>
<li id="toc-li-62">
<span href="#/text/ch017#chapter-fifteen" title="Link target outside of Sample">Chapter Fifteen</span>
<ol class="toc">
<li id="toc-li-63">
<span href="#/text/ch017#next-day-on-the-moor-road-to-norham" title="Link target outside of Sample">Next day, on the moor road to Norham…</span>
</li>
</ol>
</li>
<li id="toc-li-64">
<span href="#/text/ch018#chapter-sixteen" title="Link target outside of Sample">Chapter Sixteen</span>
</li>
<li id="toc-li-65">
<span href="#/text/ch019#chapter-seventeen" title="Link target outside of Sample">Chapter Seventeen</span>
<ol class="toc">
<li id="toc-li-66">
<span href="#/text/ch019#the-cheviots-not-long-after" title="Link target outside of Sample">The Cheviots, not long after</span>
</li>
</ol>
</li>
<li id="toc-li-67">
<span href="#/text/ch020#chapter-eighteen" title="Link target outside of Sample">Chapter Eighteen</span>
<ol class="toc">
<li id="toc-li-68">
<span href="#/text/ch020#windylaws-not-long-after" title="Link target outside of Sample">Windylaws, not long after</span>
</li>
</ol>
</li>
<li id="toc-li-69">
<span href="#/text/ch021#chapter-nineteen" title="Link target outside of Sample">Chapter Nineteen</span>
<ol class="toc">
<li id="toc-li-70">
<span href="#/text/ch021#twa-corbies-tower" title="Link target outside of Sample">Twa Corbies Tower</span>
<ol class="toc">
<li id="toc-li-71">
<span href="#/text/ch021#a-week-later" title="Link target outside of Sample">A week later</span>
</li>
</ol>
</li>
<li id="toc-li-72">
<span href="#/text/ch021#edinburgh" title="Link target outside of Sample">Edinburgh</span>
<ol class="toc">
<li id="toc-li-73">
<span href="#/text/ch021#winter-1545" title="Link target outside of Sample">Winter 1545</span>
</li>
</ol>
</li>
</ol>
</li>
<li id="toc-li-74">
<span href="#/text/ch022#authors-note" title="Link target outside of Sample">Author’s Note</span>
</li>
<li id="toc-li-75">
<span href="#/text/ch023#glossary" title="Link target outside of Sample">Glossary</span>
</li>
<li id="toc-li-76">
<span href="#/text/ch024#next-in-series" title="Link target outside of Sample">Next in Series</span>
</li>
<li class="author_bio">
<span href="#/text/author_bio" title="Link target outside of Sample">About the Author</span>
</li>
<li class="also_by">
<span href="#/text/also_by" title="Link target outside of Sample">Also by Robert Low</span>
</li>
<li id="toc-li-77">
<span href="#/text/ch025#copyright" title="Link target outside of Sample">Copyright</span>
</li>
</ol>
</nav>
<nav epub:type="landmarks" hidden="hidden" id="landmarks">
<ol>
<li>
<span epub:type="cover" href="#/text/cover" title="Link target outside of Sample">Cover</span>
</li>
<li>
<a epub:type="toc" href="#/nav#toc">Table of Contents</a>
</li>
<li>
<a epub:type="bodymatter" href="#/text/title_page">Start of Content</a>
</li>
</ol>
</nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?150bdc6e